import PropTypes from 'prop-types';

export default function FormField({ label, htmlFor, error, hint, className = '', children }) {
	const message = typeof error === 'string' && error ? error : null;

	return (
		<div className={className}>
			{label && (
				<label htmlFor={htmlFor} className="mb-1.5 block text-sm font-medium text-text">
					{label}
				</label>
			)}
			{children}
			{message ? (
				<p className="mt-1 text-xs text-warning-700">{message}</p>
			) : (
				hint && <p className="mt-1 text-xs text-bgBase-800">{hint}</p>
			)}
		</div>
	);
}

FormField.propTypes = {
	label: PropTypes.node,
	htmlFor: PropTypes.string,
	// String renders as error message below the field; booleans only mark the field via the input's own `error` prop.
	error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	hint: PropTypes.node,
	className: PropTypes.string,
	children: PropTypes.node.isRequired,
};
